export default "__VITE_PUBLIC_ASSET__29edd92b__"